import { render } from "./Transaction.vue?vue&type=template&id=1626a7e0"
import script from "./Transaction.vue?vue&type=script&lang=js"
export * from "./Transaction.vue?vue&type=script&lang=js"

import "./Transaction.vue?vue&type=style&index=0&id=1626a7e0&lang=css"

import exportComponent from "/app/vue-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__